import React, { useEffect, useRef, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";
import SelectBox from "../../../features/reduxworkbook/components/Aside2Components/DropzoneComponents/FilterConfigCompComponents/SelectBox";
import {
  getSequentialColorSceme,
  sequentialColorArray,
} from "../../../Colors/ColorControlPanel";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import FourColorBoxComp from "../../../features/reduxworkbook/components/Aside2Components/CustomizeComponent/FourColorBoxComp";

const CustomSelect = ({ options, onSelect, colorScale }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const dropdownRef = useRef(null);
  const labelOfColorScale = getSequentialColorSceme(colorScale);
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    onSelect(option);
    setIsOpen(false);
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative w-[90%] h-full" ref={dropdownRef}>
      <div
        className="p-1 border rounded border-gray-200 cursor-pointer bg-white flex items-center justify-between"
        onClick={toggleDropdown}
      >
        {labelOfColorScale
          ? labelOfColorScale.label
          : selectedOption
          ? selectedOption.label
          : "Select a color scale"}
        {isOpen ? (
          <MdKeyboardArrowUp className="relative left-1" />
        ) : (
          <MdKeyboardArrowDown className="relative left-1" />
        )}
      </div>
      {isOpen && (
        <div className="overflow-y-auto absolute z-10 w-full mt-1 bg-white border border-gray-300 shadow h-[8rem] rounded-lg flex items-start justify-between flex-col mb-4">
          {options.map((option) => (
            <div
              key={option.value}
              className=" py-2 pl-2 cursor-pointer hover:bg-gray-200 w-full rounded flex gap-2 items-center justify-between px-2"
              onClick={() => handleOptionClick(option)}
            >
              <FourColorBoxComp colors={option.colors} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default function AutoColorPoints({
  data,
  closeModal,
  conditionalFormattedData,
  modalItemIndex,
}) {
  const {
    rename,
    measure: measureObject,
    isColorScaleAuto,
    colorScale: reduxcolorScale,
    isColorInverted: reduxIsColorInverted,
  } = conditionalFormattedData?.[modalItemIndex] || {};
  const optionsArray = data.map((item) => {
    return {
      label: item.rename,
      value: item.columnName,
    };
  });
  const [selectedValue, setSelectedValue] = useState(optionsArray[0].value);
  console.log(selectedValue);
  const [colorScale, setColorScale] = useState(
    isColorScaleAuto ? reduxcolorScale : "schemeRdYlGn"
  );
  const handleValueChange = (e) => {
    console.log(e.target.value);
    const { value } = e.target;
    if (value) {
      setSelectedValue(value);
    }
  };
  const hanldeSelectColorScale = (option) => {
    const { value } = option;
    setColorScale(value);
  };
  const bgColor = getSequentialColorSceme(colorScale);
  const colorArray = Array.isArray(bgColor?.colors) ? bgColor.colors : [];
  //   console.log(colorArray);
  const saveConditionalFormatting = () => {
    const selected = data.find((item) =>
      item.dataType === "String" ? item.columnName === selectedValue : null
    );
    console.log(selected);

    if (selected) {
      const { rename, columnName, measure, nanoId } = selected;
      const isColorScaleAuto = colorScale !== "Select a color scale";

      //   Prepare the base value object
      const baseValue = {
        columnName,
        rename,
        isColorScaleAuto: true,
        rulesArray: [],
        formattingModalWas: "Auto",
        colorScale: colorScale,
        columnNanoId: nanoId,
      };
      console.log(baseValue);

      // if (modalItemIndex === -1) {
      //   dispatch(
      //     setLevel2Properties({
      //       reduxKey,
      //       Sheetid: currentSheet.Sheetid,
      //       parentKey: "customization",
      //       value: baseValue, // Send baseValue with or without colorScale
      //       itemInArray: true,
      //     })
      //   );
      // } else {
      //   const newUpdatedItem = {
      //     ...baseValue, // Reuse the same logic for updated item
      //   };
      //   console.log(newUpdatedItem);

      //   dispatch(
      //     updateLevel2Properties({
      //       reduxKey,
      //       Sheetid: currentSheet.Sheetid,
      //       parentKey: "customization",
      //       value: newUpdatedItem,
      //       itemInArray: true,
      //       index: modalItemIndex,
      //     })
      //   );
      // }
      //   closeModal();
    }
  };
  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === "Enter") {
      //   saveConditionalFormatting(); // Call your function here
    }
  };

  return (
    <main
      className="fixed inset-0 bg-gray-600 bg-opacity-50 flex flex-col items-center justify-center z-20"
      onKeyDown={handleKeyDown}
    >
      <main className="w-[43rem] h-auto bg-white shadow-2xl rounded-lg ">
        <header className="flex bg-gray-50 w-full p-2 items-center justify-between rounded-t-lg">
          Auto Color Points{" "}
          <button onClick={closeModal}>
            <FaXmark />
          </button>
        </header>
        <section className="p-2 w-full flex flex-col items-center justify-center gap-4">
          <div className="w-full items-center justify-center flex gap-2">
            <div className="flex w-1/2 items-center justify-center">
              <span className="w-[4.2rem]">Field : </span>
              <SelectBox
                value={selectedValue}
                onChange={handleValueChange}
                optionsArray={optionsArray}
              />
            </div>
            <div className="flex w-1/2 items-center justify-center">
              <span className="w-[40%]">Color Scale :</span>
              <CustomSelect
                options={sequentialColorArray}
                onSelect={hanldeSelectColorScale}
                colorScale={colorScale}
              />
            </div>
          </div>
          {/* <div className="w-full items-center justify-center flex gap-2">
            <div className="flex w-1/2 items-center justify-center">
              <span className="w-48">Apply Color on : </span>{" "}
              <SelectBox
                value={colorWillApplyOn}
                onChange={handleColorWillApplyOn}
                optionsArray={applyColorTo}
              />
            </div>
            <label className="flex w-1/2 items-center justify-left">
              <input
                type="checkbox"
                checked={isColorInverted}
                onChange={handleCheckboxChange}
                className="mr-[6px] checkbox-input"
              />
              Invert
            </label>
          </div> */}
          <div className="w-full flex items-center justify-start border p-1">
            {colorArray.length > 0 &&
              colorArray.map((color, index) => {
                return (
                  <button
                    key={index}
                    className="w-[10%] h-[27px] border flex items-center justify-center"
                    style={{
                      backgroundColor: color,
                    }}
                  ></button>
                );
              })}
          </div>
        </section>
        <footer className="flex w-full items-center justify-end gap-4 p-2">
          <button className="border w-20" onClick={closeModal}>
            Close
          </button>
          <button
            className="border w-20 bg-blue-950 text-white"
            onClick={saveConditionalFormatting}
          >
            Apply
          </button>
        </footer>
      </main>
    </main>
  );
}
